import React from 'react';

const BarChart = ({ data, max, valueFormat = (v) => v.toFixed(2), title }) => {
  const m = max || Math.max(...data.map(d => d.value), 0.0001);
  return (
    <div>
      {title && (
        <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--fg-subtle)', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 500, marginBottom: 10 }}>
          {title}
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {data.map((d, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 130, fontSize: 'var(--font-size-sm)', color: 'var(--fg)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {d.label}
            </div>
            <div style={{ flex: 1, height: 6, background: 'var(--muted)', borderRadius: 99, overflow: 'hidden' }}>
              <div style={{
                width: `${(d.value / m) * 100}%`, height: '100%',
                background: 'var(--chart-1)',
                borderRadius: 99,
                transition: 'width 480ms var(--ease-out)',
              }} />
            </div>
            <div style={{ width: 52, fontSize: 'var(--font-size-xs)', color: 'var(--muted-foreground)', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>
              {valueFormat(d.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BarChart;
